/* THE NORVA RESET — lander capture
   Mirrors the norva-quiz Klaviyo client-API pattern:
   (1) subscribe profile to the Reset list with goal stored as a property
   (2) fire the "Started Reset Challenge" metric that triggers the flow
   (3) fbq Lead + CompleteRegistration for Meta optimisation */
(function () {
  'use strict';

  var root = document.querySelector('[data-norva-reset]');
  if (!root) return;

  var configEl = root.querySelector('[data-nr-config]');
  var config = {};
  try { config = JSON.parse(configEl.textContent); } catch (e) { /* leave empty */ }

  var form = root.querySelector('[data-nr-form]');
  var successWrap = root.querySelector('[data-nr-success]');
  if (!form) return;

  var emailInput = form.querySelector('[data-nr-email]');
  var nameInput = form.querySelector('[data-nr-first-name]');
  var errorEl = form.querySelector('[data-nr-error]');
  var submitBtn = form.querySelector('[data-nr-submit]');
  var submitLabel = form.querySelector('[data-nr-submit-label]');

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function jsonPost(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(payload)
    });
  }

  function sendToKlaviyo(email, firstName, goal) {
    if (!config.klaviyoCompanyId) return Promise.resolve();

    var properties = {
      'Reset Goal': goal,
      'Reset Source': config.customSource,
      'Reset Start Date': new Date().toISOString().slice(0, 10)
    };

    var profileAttributes = { email: email, properties: properties };
    if (firstName) profileAttributes.first_name = firstName;

    var calls = [];

    if (config.klaviyoListId) {
      calls.push(jsonPost(
        'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(config.klaviyoCompanyId),
        {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: config.customSource,
              profile: { data: { type: 'profile', attributes: profileAttributes } }
            },
            relationships: { list: { data: { type: 'list', id: config.klaviyoListId } } }
          }
        }
      ));
    }

    calls.push(jsonPost(
      'https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(config.klaviyoCompanyId),
      {
        data: {
          type: 'event',
          attributes: {
            metric: { data: { type: 'metric', attributes: { name: config.metricName } } },
            properties: properties,
            profile: { data: { type: 'profile', attributes: profileAttributes } }
          }
        }
      }
    ));

    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify(Object.assign({ $email: email, $first_name: firstName || '' }, properties));
      }
    } catch (e) { /* non-fatal */ }

    return Promise.allSettled ? Promise.allSettled(calls) : Promise.all(calls.map(function (p) { return p.catch(function () {}); }));
  }

  function trackLead(goal) {
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Lead', { content_name: 'Norva Reset Challenge', content_category: goal });
        window.fbq('track', 'CompleteRegistration', { content_name: 'Norva Reset Challenge', status: goal });
      }
    } catch (e) { /* non-fatal */ }
    try {
      if (window.gtag) window.gtag('event', 'generate_lead', { event_category: 'reset-challenge', event_label: goal });
    } catch (e) { /* non-fatal */ }
  }

  function showSuccess(email) {
    form.hidden = true;
    if (successWrap) {
      successWrap.hidden = false;
      var emailEl = successWrap.querySelector('[data-nr-success-email]');
      if (emailEl) emailEl.textContent = email;
      successWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    try { localStorage.setItem('nr_joined', '1'); } catch (e) { /* private mode */ }
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    var email = (emailInput.value || '').trim();
    var firstName = (nameInput && nameInput.value || '').trim();
    var goalInput = form.querySelector('input[name="reset_goal"]:checked');
    var goal = goalInput ? goalInput.value : 'Recovery';

    if (!EMAIL_RE.test(email)) {
      if (errorEl) errorEl.hidden = false;
      emailInput.focus();
      return;
    }
    if (errorEl) errorEl.hidden = true;

    submitBtn.disabled = true;
    if (submitLabel) submitLabel.textContent = 'Starting your Reset…';

    trackLead(goal);
    sendToKlaviyo(email, firstName, goal)
      .catch(function () { /* never block the user on network */ })
      .then(function () { showSuccess(email); });
  });

  /* Smooth-scroll the final CTA back to the form */
  var scrollLink = root.querySelector('[data-nr-scroll]');
  if (scrollLink) {
    scrollLink.addEventListener('click', function (event) {
      var anchor = document.getElementById('nr-form-anchor');
      if (anchor) {
        event.preventDefault();
        anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var focusTarget = nameInput || emailInput;
        if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 450);
      }
    });
  }
})();
